import React, { createContext, useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { venueLog } from '../utils/Accesslog.js';
import { resolveVenueIdFromLocation } from '../utils/venueParam.js';

const AppContext = createContext();

export const AppProvider = ({ children, venueId: providedVenueId }) => {
    const [searchParams] = useSearchParams();
    const venueId = providedVenueId || resolveVenueIdFromLocation({ search: searchParams.toString(), hostname: window.location.hostname });
    const [hotelInfo, setHotelInfo] = useState(null);
    const [theme, setTheme] = useState(); //这个纯粹为了读取theme方便  二更：max的g老师建议删除null,
    const [contentInfo, setContentInfo] = useState(null);
    const [articleInfo, setArticleInfo] = useState(null)
    const [advInfo, setAdvInfo] = useState(null);
    const [suspended, setSuspended] = useState(false); //全局场馆是否被暂停

    useEffect(() => {
        let isMounted = true;
        if (!venueId) {
            return;
        }

        const fetchHotelData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/public/home/${venueId}`);
                const data = await response.json();
                if (isMounted) {
                    setHotelInfo(data);
                    setTheme(data.theme?.configuration || [])
                    const isActive = data?.validity?.isActive === true;
                    setSuspended(!isActive);
                }
            } catch (error) {
                console.error("Error fetching hotel data:", error);
            }
        };
        fetchHotelData();
        return () => {
            isMounted = false;
        };
    }, [venueId]);

    useEffect(() => {
        let isMounted = true;
        if (!venueId) {
            return;
        }

        const fetchContentData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/public/content/${venueId}`);
                const data = await response.json();
                if (isMounted) {
                    setContentInfo(data);
                }
            } catch (error) {
                console.error("Error fetching content data:", error);
            }
        };
        fetchContentData();
        return () => {
            isMounted = false;
        };
    }, [venueId]);

    useEffect(() => {
        let isMounted = true;
        if (!venueId) {
            return;
        }

        const fetchArticleData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/public/article/${venueId}`);
                const data = await response.json();
                if (isMounted && Array.isArray(data)) {
                    // Find the index of the item that has masterEntry: true then sort array
                    const index = data.findIndex(item => item.masterEntry === true);
                    if (index > 0) {
                        const [masterItem] = data.splice(index, 1);
                        data.unshift(masterItem);
                    }
                    setArticleInfo(data);
                }
            } catch (error) {
                console.error("Error fetching hotel data:", error);
            }
        };
        fetchArticleData();
        return () => {
            isMounted = false;
        };
    }, [venueId]);

    useEffect(() => {
        let isMounted = true;
        if (!venueId) {
            return;
        }

        const fetchAdvData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/public/adv/${venueId}`);
                const data = await response.json();
                if (isMounted) {
                    setAdvInfo(data);
                }
            } catch (error) {
                console.error("Error fetching adv data:", error);
            }
        };
        fetchAdvData();
        return () => {
            isMounted = false;
        };
    }, [venueId]);

    // pure analysis api
    useEffect(() => {

        if (!venueId) {
            return;
        }

        let active = true;
        let timer;
        const scheduleNextExecution = () => {
            const nextExecutionTime = Date.now() + 60000;
            venueLog(venueId).finally(() => {
                if (!active) return;
                const delay = Math.max(0, nextExecutionTime - Date.now());
                timer = setTimeout(scheduleNextExecution, delay);
            });
        };
        scheduleNextExecution();
        return () => {
            active = false;
            clearTimeout(timer);
        };
    }, [venueId]);

    useEffect(() => {
        // 暴露一个全局函数，任何地方都可以调用来更新预览主题
        window.__APPLY_PREVIEW_THEME__ = (payload) => {
            if (!payload) return;
            // 你可以兼容两种格式：{ colors, configuration } 或直接 configuration
            const conf = payload.configuration || payload;
            setTheme(conf);
            // 如果你有“CSS 变量兜底”的函数，这里也一并应用
            try {
                const root = document.documentElement;
                Object.entries(conf || {}).forEach(([k, v]) => {
                    if (v) root.style.setProperty(`--${k}`, String(v));
                });
            } catch { }
        };

        // 同时支持 postMessage 注入（可选）
        const onMsg = (e) => {
            const data = e.data && e.data.__PREVIEW_THEME__;
            if (data) window.__APPLY_PREVIEW_THEME__(data);
        };
        window.addEventListener('message', onMsg);
        return () => window.removeEventListener('message', onMsg);
    }, []);

    return (
        <AppContext.Provider value={{
            venueId, hotelInfo, contentInfo, articleInfo, advInfo, theme, setTheme, suspended
        }}>
            {children}
        </AppContext.Provider>
    );
};

export default AppContext;
